import React, { useState, useRef, useEffect } from 'react';
import { toISODate, fromISODate, todayISO, MONTHS, WEEKDAYS, formatDate } from '../dateUtils';

// Кастомный календарь для выбора даты (работает одинаково на всех устройствах)
export default function DatePicker({ value, onChange, placeholder }) {
  const [open, setOpen] = useState(false);
  const [viewYear, setViewYear] = useState(() => fromISODate(value).getFullYear());
  const [viewMonth, setViewMonth] = useState(() => fromISODate(value).getMonth());
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleCalendar = () => {
    const base = value ? fromISODate(value) : new Date();
    setViewYear(base.getFullYear());
    setViewMonth(base.getMonth());
    setOpen(o => !o);
  };

  const prevMonth = () => {
    let y = viewYear;
    let m = viewMonth - 1;
    if (m < 0) { m = 11; y -= 1; }
    setViewYear(y);
    setViewMonth(m);
  };

  const nextMonth = () => {
    let y = viewYear;
    let m = viewMonth + 1;
    if (m > 11) { m = 0; y += 1; }
    setViewYear(y);
    setViewMonth(m);
  };

  const selectDay = (day) => {
    onChange(toISODate(new Date(viewYear, viewMonth, day)));
    setOpen(false);
  };

  // Сетка дней (неделя начинается с понедельника)
  const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
  const startOffset = (new Date(viewYear, viewMonth, 1).getDay() + 6) % 7;
  const today = todayISO();
  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <div className="date-picker" ref={ref}>
      <div className="date-picker-input" onClick={toggleCalendar} role="button" tabIndex="0">
        <span className={value ? '' : 'date-picker-placeholder'}>
          {value ? formatDate(value) : (placeholder || 'Выберите дату')}
        </span>
        <span className="date-picker-icon">📅</span>
      </div>

      {open && (
        <div className="calendar-popup">
          <div className="calendar-header">
            <button type="button" className="cal-nav" onClick={prevMonth}>‹</button>
            <span className="cal-month">{MONTHS[viewMonth]} {viewYear}</span>
            <button type="button" className="cal-nav" onClick={nextMonth}>›</button>
          </div>

          <div className="calendar-weekdays">
            {WEEKDAYS.map(w => <span key={w}>{w}</span>)}
          </div>

          <div className="calendar-days">
            {cells.map((d, i) => {
              if (d === null) return <span key={`e${i}`} className="cal-empty" />;
              const iso = toISODate(new Date(viewYear, viewMonth, d));
              return (
                <button
                  key={iso}
                  type="button"
                  className={`cal-day${iso === today ? ' today' : ''}${iso === value ? ' selected' : ''}`}
                  onClick={() => selectDay(d)}
                >
                  {d}
                </button>
              );
            })}
          </div>

          <button type="button" className="cal-today" onClick={() => { onChange(today); setOpen(false); }}>
            Сегодня
          </button>
        </div>
      )}
    </div>
  );
}
